import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { LicenseInfo } from "@mui/x-license";

import { QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider as NextThemeProvider } from "next-themes";
import { AuthContextProvider } from "./context/AuthContext";
import { smallDataQueryClient } from "./clients/SmallDataQueryC";

// LicenseInfo.setLicenseKey(process.env.REACT_APP_MUIX_LICENSE);
LicenseInfo.setLicenseKey(
  "be85e0445399641894a9a27136f2e5b2Tz0xMDc3NjgsRT0xNzcwOTQwNzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI="
);

console.log("Used .ENV File:", process.env.REACT_APP_ENV);
console.log("Used Backend URL:", process.env.REACT_APP_BACKEND_URL);
console.log("Used WS URL:", process.env.REACT_APP_WS_URL);

// const queryClient = new QueryClient({
//   defaultOptions: {
//     queries: {
//       staleTime: Infinity,
//     },
//   },
// });

// const localStoragePersister = createSyncStoragePersister({
//   storage: window.localStorage,
//   serialize: (data) => {
//     const preSerialized = preSerialize(data);
//     return compress(preSerialized);
//   },
//   deserialize: (data) => {
//     const decompressed = decompress(data);
//     return preDeserialize(decompressed);
//   },
// });

// persistQueryClient({
//   queryClient,
//   persister: localStoragePersister,
//   maxAge: Infinity,
// });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={smallDataQueryClient}>
    <AuthContextProvider>
      <NextThemeProvider attribute="class" defaultTheme="Light" enableSystem>
        <App />
      </NextThemeProvider>
    </AuthContextProvider>
  </QueryClientProvider>
);

reportWebVitals();
